import React from 'react';
import Sidebar from './Sidebar';
import AnnouncementBanner from './AnnouncementBanner';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen grid grid-rows-[auto_1fr] bg-light-gold">
      <AnnouncementBanner />
      <div className="flex min-h-0 min-w-0 row-start-2">
        <Sidebar />
        <main className="flex-1 min-w-0">{children}</main>
      </div>
    </div>
  );
}
